import styled from 'styled-components';

import { IFeature, IGlassesPackage } from '../../types';
import {
    PackageDiscountBadge,
    PackagePriceCurrent,
    PackagePriceDisplay,
    PackagePriceOriginal,
    PackagePriceWrapper,
} from './PackagePriceDisplay';
import { FeatureList } from '../FeatureList';
import { breakpoints, spacing } from '../../constants';
import { applyDiscount, displayPrice } from '../../utils';

const HeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: ${spacing.lg};
    margin-bottom: 20px;
    margin-top: 60px;

    @media (${breakpoints.mediumMin}) {
        padding-right: 40px;
        padding-bottom: 0;
        margin-top: 0;
        flex-direction: row;
    }
`;

const PackageName = styled.h3`
    font-size: 2.4rem;
    line-height: 1;
    margin-bottom: 20px;

    @media (${breakpoints.mediumMin}) {
        margin-bottom: 0;
    }

    span {
        font-weight: 400;
    }
`;

interface IProps {
    features: IFeature[];
    selectedPackage: IGlassesPackage;
    className?: string;
}

const BaseGlassesPackageDisplay = ({
    features,
    selectedPackage,
    className,
}: IProps) => {
    const { priceInt, discountPercentage } = selectedPackage;
    const hasDiscount = !!discountPercentage && discountPercentage > 0;
    const displayedPrice = hasDiscount
        ? applyDiscount(priceInt, discountPercentage)
        : priceInt;

    return (
        <div className={className}>
            <HeaderRow>
                <PackageName>
                    {selectedPackage.name}
                    {selectedPackage.name !== 'Basis' && (
                        <>
                            <br />
                            <span>glaspakket</span>
                        </>
                    )}
                </PackageName>
                <PackagePriceWrapper>
                    {hasDiscount && (
                        <PackageDiscountBadge>
                            <span>{discountPercentage}%</span>
                            <small>korting</small>
                        </PackageDiscountBadge>
                    )}
                    <PackagePriceDisplay
                        textColor={selectedPackage.textColorGeneral}
                    >
                        {hasDiscount && (
                            <PackagePriceOriginal>
                                {displayPrice(priceInt)}
                            </PackagePriceOriginal>
                        )}
                        <PackagePriceCurrent>
                            {displayPrice(displayedPrice)}
                        </PackagePriceCurrent>
                    </PackagePriceDisplay>
                </PackagePriceWrapper>
            </HeaderRow>
            <FeatureList features={features} glassesPackage={selectedPackage} />
        </div>
    );
};

export const GlassesPackageDisplay = styled(BaseGlassesPackageDisplay)`
    @media (${breakpoints.mediumMin}) {
        flex: 0 0 45%;
    }
`;
